declare global {
  interface Window {
    Telegram?: {
      WebApp?: {
        initData?: string;
        platform?: string;
        ready?: () => void;
        expand?: () => void;
        openLink?: (
          url: string,
          options?: { try_instant_view?: boolean },
        ) => void;
      };
    };
  }
}

/** True when running inside Telegram Mini App WebView (not native Capacitor). */
export function isTelegramMiniApp(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const webApp = window.Telegram?.WebApp;
  if (!webApp) {
    return false;
  }

  const platform = webApp.platform?.trim();
  if (platform && platform !== 'unknown') {
    return true;
  }

  return !!webApp.initData?.trim();
}

/** Calls Telegram WebApp SDK hooks when running inside Mini App. */
export function initializeTelegramWebApp(): void {
  if (!isTelegramMiniApp()) {
    return;
  }

  const webApp = window.Telegram?.WebApp;
  webApp?.ready?.();
  webApp?.expand?.();
}
